var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { put, call, takeLatest } from 'redux-saga/effects';
import { fromJS } from 'immutable';
import store from 'store';
import history from '@store/history';
import errorHandler from 'services/connection';
import { getThemeComplete } from '@store/theme/actions';
import { getDevicesComplete, getDevices as getDevicesAction, getDeviceTheme as getDeviceThemeAction, } from './actions';
export function getDevices(api) {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.get], 'devices', {
                        params: {
                            occupied: false,
                        },
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, put(getDevicesComplete(fromJS(response.body)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_1, getDevicesComplete, getDevicesAction))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function getDeviceTheme(api, action) {
    var body, switches, localStorageCustomerId, localStorageStoreId, localStorageCurrency, localStorageCurrencySign, localBranchSelectionEnabled, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, call([api, api.get], "devices/" + action.payload + "/themes")];
            case 1:
                body = (_a.sent()).body;
                switches = body.switches;
                localStorageCustomerId = store.get('customerId');
                if (localStorageCustomerId !== body.customerId) {
                    store.set('customerId', body.customerId);
                    store.remove("currentUserId");
                    history.push('/login');
                }
                localStorageStoreId = store.get('storeId');
                if (localStorageStoreId !== body.storeId) {
                    store.set('storeId', body.storeId);
                }
                localStorageCurrency = store.get('currency');
                if (localStorageCurrency !== body.currency) {
                    store.set('currency', body.currency);
                    window.location.reload();
                }
                localStorageCurrencySign = store.get('currencySign');
                if (localStorageCurrencySign !== body.currencySign) {
                    store.set('currencySign', body.currencySign);
                    window.location.reload();
                }
                localBranchSelectionEnabled = store.get('branchSelectionEnabled');
                if (localBranchSelectionEnabled !== body.branchSelectionEnabled) {
                    store.set('branchSelectionEnabled', body.branchSelectionEnabled);
                    window.location.reload();
                }
                store.set('switches', switches || {
                    buy: true,
                    request: false,
                    reserve: true,
                    requestStock: true,
                });
                return [4 /*yield*/, put(getThemeComplete(fromJS(body)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                error_2 = _a.sent();
                return [4 /*yield*/, put(errorHandler(error_2, getThemeComplete, getDeviceThemeAction, action.payload))];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
export function devicesWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_DEVICES', getDevices, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function deviceThemeWatcher(_a) {
    var api = _a.api;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, takeLatest('GET_DEVICE_THEME', getDeviceTheme, api)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
